import saveBlockContentFromUnknownSendersService from '../services/saveBlockContentFromUnknownSendersService';
import saveFiltersOptionHelper from '../mutators/saveFiltersOptionMutator';
import saveMailboxJunkEmailConfiguration from 'owa-junkmail-configuration/lib/services/setMailboxJunkEmailConfiguration';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { getUserConfiguration } from 'owa-session-store';

export default async function saveFiltersOption() {
    // Update local mailboxJunkEmailConfiguration
    const userConfiguration = getUserConfiguration();
    const mailboxJunkEmailConfigurationBeforeUpdatingStore = await getMailboxJunkEmailConfiguration();

    saveFiltersOptionHelper(mailboxJunkEmailConfigurationBeforeUpdatingStore, userConfiguration);
    const mailboxJunkEmailConfigurationAfterUpdatingStore = await getMailboxJunkEmailConfiguration();

    // Save trustedListsOnly && contactsTrusted service call
    await saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfigurationAfterUpdatingStore);

    // Save blockContentFromUnknownSenders service call
    await saveBlockContentFromUnknownSendersService();
}
